export default __webpack_public_path__ + "assets/images/1916327db139aa3d0451e68f3c1b2925.png";